// React imports.
import React, { Component } from "react";
import { GraphType } from "../state";
import {  IReportResults, IReportResultColumn, convertTableToCSV } from "../utility";


const ReportDataTable = ({ reportData, caption}) => {

  const tableRef = React.useRef<HTMLTableElement>(null);

  const removeInvalidCharactersFromFilename = (filename: string): string => {
    const invalidCharacters = /[\\/:"*?<>|]/g;
    const replacementCharacter = "_";
    return filename.replace(invalidCharacters, replacementCharacter);
  }

  const handleDownloadCSV = () => {
    if (!tableRef.current) return;

    const csv = convertTableToCSV(tableRef.current)
      + '\n\n'
      + 'Source: LIHEAP Performance Measurement Web Site(https://liheappm.acf.hhs.gov)';

    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    link.download = `${removeInvalidCharactersFromFilename(caption ??'DownloadData')}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{width:"100%", overflow:"scroll"}}>
      <table className="dataTable" ref={tableRef}>
        <caption>{caption}</caption>
        <tbody>
          <tr>
            {(Object.keys(reportData.reportData[0]) as string[])
              .map(tr => (
                <th>{tr}</th>
              ))}
          </tr>
          {reportData.reportData.map(row => (
            <tr>
              {(Object.values(row) as string[])
                .map((tr, idx) => (
                  <React.Fragment>
                    {(idx < 2)
                      && <th>{tr}</th>
                    }
                    {(idx > 1)
                      && <td>{tr}</td>
                    }

                  </React.Fragment>
                ))}
            </tr>
          ))}
        </tbody>
      </table>
      <button className="dataButton" onClick={handleDownloadCSV}>Export table data into CSV/Excel file</button>
    </div>
  );
}

export default ReportDataTable;
